export namespace IAntiTheft {
  export const Action = 'carThefts';

  export enum Command {
    GetCars = 'getCars',
    GetSchedule = 'getSchedule',
    SetSchedule = 'setSchedule',
    SetStatus = 'setStatus',
  }

  export interface IScheduleItem {
    carNumber: string;
    times: string[][];
    day: number;
    dayName: string;
    enabled: boolean;
    id: number;
  }

  export interface IStatusCars {
    carId: number;
    carNumber: string;
    problemFlag: boolean;
    theftFlag: boolean;
    theftScheduleFlag: boolean;
    theftScheduleActive: boolean;
  }

  export enum BusEvents {
    GetCars = 'anti-theft:get-cars',
    UpdateSecurity = 'anti-theft:update-security',
  }
}
